export const AUTH_ORG_COOKIE_NAME = 'orgId';
export const AUTH_ORG_QUERY_PARAM_NAME = 'organization';
export const AUTH_INVITATION_QUERY_PARAM_NAME = 'invitation';
export const UTM_COOKIE_NAME = 'utm';
export const IS_INVITATION_QUERY_PARAM_NAME = 'isInvitation';
